  import { Component,Inject, ViewEncapsulation } from '@angular/core';
  import { MatDialogRef } from '@angular/material';
  import { Subscription } from 'rxjs/Subscription';
  import { MAT_DIALOG_DATA} from '@angular/material';
  import { FormBuilder, FormGroup, Validators } from '@angular/forms';
  import { NotifierService } from '../../../shared/notifier/notifier.service';
  
  @Component({
    selector: 'app-create-global-discount',
    templateUrl: `create-global-discount.html`,
    encapsulation: ViewEncapsulation.None,
  })
  export class CreateGlobalDiscountComponent {
  
    modalTitle = '';
    buttonText = '';
    submitted = false;
    subscription: Subscription;
    action: string;
    summit: boolean;
    discount = {details: '', value: 0, type: 1 , lineSelect: 0};
    registerForm: FormGroup;
    constructor(public dialogRef: MatDialogRef<CreateGlobalDiscountComponent>,
      @Inject(MAT_DIALOG_DATA) public dialogData: any,
      private formBuilder: FormBuilder,
      private notifierService: NotifierService,
      ) {
        if (this.discount.type == 1){
          this.registerForm = this.formBuilder.group({
            discount_type: ['', Validators.required],
            value: ['', [Validators.required, Validators.max(100),Validators.min(0)]]
          });
        } else {
          this.registerForm = this.formBuilder.group({
            discount_type: ['', Validators.required],
            value: ['', [Validators.required]]
          });
        }
      }
  
    get f() { return this.registerForm.controls; }
  
    close() {
      this.dialogRef.close();
    }
  
    changePorcent() {
        if (this.discount.value > 100 || this.discount.value < 0){
          this.discount.value = 0;
        }
    }
  
    changeMount() {
      if (this.discount.value < 0){
          this.discount.value = 0;
      }
    }
  
    public onSave() {
      this.submitted = true;
          this.dialogRef.close(this.discount);
      
    }
 }





// WEBPACK FOOTER //
// ./src/app/system/budget/new-budget/create-global-discount/create-global-discount.component.ts